import { useContext } from "react";

import styled from "styled-components";

import FnrButtonWrapper from "UI/FnrButtonWrapper";
import FnrChevron from "UI/FnrChevron";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import { FnrAccordionContext } from "./FnrAccordion";

const translateWhenActive = ({ $active }) => {
  return `transform: translateY(${
    $active ? "0px" : "-8px"
  }); transition: transform .3s;`;
};

const SFnrHorizontalGap = styled(FnrHorizontalGap)`
  height: 0px;
  ${translateWhenActive}
`;

const CenteredChevron = () => {
  const { handleToggle, active, dark } = useContext(FnrAccordionContext);
  return (
    <SFnrHorizontalGap justifyContent="center" $active={active}>
      <FnrButtonWrapper onClick={handleToggle}>
        <FnrChevron active={active} dark={dark} flat />
      </FnrButtonWrapper>
    </SFnrHorizontalGap>
  );
};

export default CenteredChevron;
